import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ProTokenService } from './pro-token.service';

@Injectable({
  providedIn: 'root',
})

export class ProAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: ProTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}